/**
 * Paleta canônica de cores de sessão.
 *
 * Fonte ÚNICA: o seletor de cor (`app-color-picker`) desenha as amostras a
 * partir daqui, e o programa exportado usa os NOMES para batizar as classes —
 * `class="session session-color-sky"` se lê, `session-color-bfe7ff` não.
 *
 * Os nomes são em inglês de propósito: viram classe de CSS num arquivo que
 * circula, e nomes de cor em inglês são o vocabulário corrente de CSS.
 * Cores fora desta paleta continuam identificadas pelo hexadecimal.
 */
export interface PaletteColor {
  /** Sufixo da classe: `session-color-<name>`. */
  name: string;
  hex: string;
}

export const SESSION_PALETTE: PaletteColor[] = [
  { name: 'sky',       hex: '#BFE7FF' },
  { name: 'azure',     hex: '#B7DBF5' },
  { name: 'steel',     hex: '#C8D9F0' },
  { name: 'periwinkle', hex: '#D3D0F0' },
  { name: 'indigo',    hex: '#C6C3F0' },

  { name: 'lilac',     hex: '#E6CFEF' },
  { name: 'orchid',    hex: '#EFC9E4' },
  { name: 'rose',      hex: '#F5CEDD' },
  { name: 'blush',     hex: '#F7CFC7' },
  { name: 'peach',     hex: '#F6DFC0' },

  { name: 'butter',    hex: '#F3EFC0' },
  { name: 'lime',      hex: '#E6F0BE' },
  { name: 'sage',      hex: '#DDEFC2' },
  { name: 'mint',      hex: '#C4E9CE' },
  { name: 'aqua',      hex: '#C0E7E2' },

  { name: 'stone',     hex: '#E4E1DE' },
  { name: 'ash',       hex: '#CFCCC8' },
  { name: 'gray',      hex: '#A8A5A0' },
  { name: 'slate',     hex: '#8FA6B8' },
  { name: 'charcoal',  hex: '#5B6B7A' },
];

/** Nome da cor na paleta, ou `null` se ela não estiver lá. */
export function paletteNameOf(color: string): string | null {
  if (!color) { return null; }
  const value = color.toLowerCase();
  const found = SESSION_PALETTE.find(entry => entry.hex.toLowerCase() === value);
  return found ? found.name : null;
}
